import { Texts, Media, Button } from "../Object";
import { Space } from "../Layout";

const Banner = (props) => {

  return (
    <>
      <div className="l-row">
        <Button link="/service">
          <Media src="common/banner" alt="banner" sp="sp" class="p-img__banner"></Media>
        </Button>
      </div>
    </>
  );
};

export default Banner;
